import { ButtonStyled } from "theme/common/Button.styled"
import ContentDetailOrderActionsStyled from "theme/common/ContentDetailOrderActions.styled"
import { IconCheck } from "theme/common/Icon.styled"
import { ITransitAction } from "interfaces/IShippingGroupAction"
import { useLocation } from "react-router-dom"
import { useEffect, useState, useContext, useRef, MouseEvent } from "react"
import { AuthContext } from "context/context/AuthContext"
import { ResourcePermissionsEnum } from "enums/ResourcePermissionsEnum"
import useUserPermissions from "hooks/UseUserPermissions"
import Modal from "components/Commons/Modal/Modal"
import WindowModal from "components/Commons/WindowModal/WindowModal"

interface ITransitActionExtended extends ITransitAction {
  onSubmit?: () => void
}

const TransitAction = ({ loadingTransit, disabledButton, onSubmit }: ITransitActionExtended) => {
  // TODO: This could be refactorized
  const { pathname } = useLocation<{ type: string }>()
  const authState = useContext(AuthContext)
  const website: any = authState?.state.user?.mainGroup.id
  let transit_to_source = pathname.includes("transit_to_source")
  let text_in_transit_for_reception = pathname.includes("in_transit_for_reception")
  let in_transit_for_reception_opl = pathname.includes("in_transit_for_reception_opl")
  const [canIuseUpdateCourierDelivery, setCanIuseUpdateCourierDelivery] = useState(false)
  const { permission } = useUserPermissions({ resources: [ResourcePermissionsEnum.confirmReceptionOpl] });
  const refModalConfirm = useRef<React.ElementRef<typeof Modal>>(null)
  
  
  useEffect( () => {
    permission[ResourcePermissionsEnum.confirmReceptionOpl] && setCanIuseUpdateCourierDelivery(true) 
  }, [permission])

  if (website === "privilege" && !transit_to_source) return null
  if (in_transit_for_reception_opl && canIuseUpdateCourierDelivery) return null

  const renderBtnTitle = (): string => {
    if(transit_to_source)  return "recibido"
    if(text_in_transit_for_reception) return "recepción"

    return "entrega"
  }

  const handleAction = (e: MouseEvent<HTMLButtonElement>) => {    
    e.preventDefault()
    e.stopPropagation()

    if(text_in_transit_for_reception) {
      refModalConfirm?.current?.open()
    } else if(onSubmit) {
      onSubmit()
    }
  }

  const handleConfirmAction = () => {
    refModalConfirm.current?.close()
    // Ejecutar el submit después de confirmar
    if (onSubmit) {
      onSubmit()
    }
  }

  return (
    <>
      <Modal ref={refModalConfirm}>
        <WindowModal
          title="Confirmación"
          description="¿Estás seguro que deseas confirmar la recepción de esta orden? Recuerda asegurarte de que el paquete se encuentra físicamente en la tienda."
          handleConfirm={handleConfirmAction}
          handleCancel={() => refModalConfirm.current?.close()}
        />
      </Modal>
      
      <ContentDetailOrderActionsStyled>
        <ButtonStyled variant="primary" loadingButton={loadingTransit} disabled={loadingTransit} disabledButton={disabledButton} onClick={handleAction}>
          <IconCheck />
          <span>Confirmar {renderBtnTitle()}</span>
        </ButtonStyled>
      </ContentDetailOrderActionsStyled>
    </>
  )
}

export default TransitAction
